// const BASE_URL= 'https://sandbox.cowin.gov.in';
// const DIRECT_BASE_URL= 'https://sandbox.cowin.gov.in';
const BASE_URL= 'https://cdndemo-api.co-vin.in';
const DIRECT_BASE_URL= 'https://cdndemo-api.co-vin.in';

const API_ADMIN_PORT = ``;
const API_AUTH_PORT = ``;
const API_USER_PORT = ``;
const API_REGISTRATION_PORT = ``;
const API_SESSION_PORT = ``;
const API_REPORTS_PORT = ``;
const APPOINTMENT_PORT = ``;
const SELF_REGISTRATION_URL = `https://selfregistration.demo.co-vin.in`;


export const environment = {
  production: false,
  international: true,
  bucket: "SIT",
  defaultLanguage: 'en',
  supportedLanguages: [
    { id: 'en', name: 'English', regional: 'English' },
    { id: 'hi', name: 'Hindi', regional: 'हिंदी' },
    { id: 'mr', name: 'Marathi', regional: 'मराठी' },
    { id: 'ml', name: 'Malayalam', regional: 'മലയാളം' },
    { id: 'pb', name: 'Punjabi', regional: 'ਪੰਜਾਬੀ' },
    { id: 'te', name: 'Telugu', regional: 'తెలుగు' },
    { id: 'gu', name: 'Gujarati', regional: 'ગુજરાતી' },
    { id: 'as', name: 'Assamese', regional: 'অসমীয়া' },
    { id: 'be', name: 'Bengali', regional: 'বাংলা' },
    { id: 'ka', name: 'Kannada', regional: 'ಕನ್ನಡ' },
    { id: 'or', name: 'Odia', regional: 'ଓଡିଆ' },
    { id: 'ta', name: 'Tamil', regional: 'தமிழ்' },
  ],
  socket_live_counter_url_port: `wss://websocketprod.co-vin.in`,
  session_prefix_url_port: `${BASE_URL}:9005`,
  session_prefix_url: `${BASE_URL}${API_SESSION_PORT}/api/v1/session`,
  admin_prefix_url: `${BASE_URL}${API_ADMIN_PORT}/api/v1/admin`,
  auth_prefix_url: `${BASE_URL}${API_AUTH_PORT}/api/v1/auth`,
  user_prefix_url: `${BASE_URL}${API_USER_PORT}/api/v1/user`,
  beneficiary_registration_prefix_url: `${BASE_URL}${API_REGISTRATION_PORT}/api/v1/registration`,
  admin_prefix_direct_url: `${DIRECT_BASE_URL}${API_ADMIN_PORT}/api/v1/admin`,
  beneficiary_registration_prefix_direct_url: `${DIRECT_BASE_URL}${API_REGISTRATION_PORT}/api/v1/registration`,
  report_prefix_direct_url: `${BASE_URL}${API_REPORTS_PORT}/api/v1/reports`,
  admin_prefix_url_v2:`${BASE_URL}${API_ADMIN_PORT}/api/v2/admin`,
  appointment_url_v2:`${BASE_URL}${APPOINTMENT_PORT}/api/v2/appointment`,
  appointment_url_v4:`${BASE_URL}${APPOINTMENT_PORT}/api/v4/appointment`,
  rd_device_prefix_url: `https://localhost:`,
  recaptcha_site_key: '6Ldegm4bAAAAAL2PlGwQQmqFzI7LhNSahaKsGl6E',
  selfregistration: `${SELF_REGISTRATION_URL}`,
  isUat: false,
  chatboturl: 'https://covid19-staging.nhp.gov.in:80/vaccinator/',
  isProduction: false,
  env: 'OtherEnv',
  apkVersion: '3.0',
  playStoreUrl: {
    android: 'https://play.google.com/store/apps/details?id=com.cowinapp.app',
    ios: '',
  },
  AppRedirectUrls: {
    admin: 'https://admin.demo.co-vin.in',
    webApp: 'https://app.demo.co-vin.in',
    selfReg: 'https://selfregistration.demo.co-vin.in/',
    trackReg: 'https://selfregistration.demo.co-vin.in/applicationtracker',
    certificate: 'http://selfregistration.demo.co-vin.in/vaccination-certificate',
    dashboard: 'https://dashboard.demo.co-vin.in',
    international: 'https://sandbox.demo.co-vin.in',
    verifyCertificate: 'https://verify.cowin.gov.in/',
    dashboardInd: 'https://dashboard.demo.co-vin.in',
    mainPage: 'https://demo.co-vin.in',
    shareStatusUrl: 'https://cdndemo-api.co-vin.in/api/v3/vaccination/status/knowYourStatus'
  },
  mmi:{
    mapload_url:"https://apis.mapmyindia.com/advancedmaps/v1/0e644b9813e32d4195ddb1acf396579e/map_load?v=1.5",
    mapsdk_url:"https://apis.mapmyindia.com/advancedmaps/api/0e644b9813e32d4195ddb1acf396579e/map_sdk_plugins"
  }

};
